
















































import { Resource } from "@/types";
import ExternalResource from "@/components/ExternalResource.vue";
import Ace from "@/components/Ace.vue";
import { useTogglable } from "@/compositions/useTogglable";
import { defineComponent } from "@vue/composition-api";
import { useHtml } from "@/compositions/useHtml";
interface Props {
  scripts: Resource[];
  styles: Resource[];
  code: string;
}
export default defineComponent({
  components: {
    ExternalResource,
    Ace
  },
  setup() {
    const {
      styles,
      scripts,
      inlineScript,
      addScript,
      addStyle,
      removeScript,
      removeStyle
    } = useHtml();
    return {
      styles,
      scripts,
      code: inlineScript,
      addScript,
      addStyle,
      removeScript,
      removeStyle,
      ...useTogglable()
    };
  }
});
